export default __webpack_public_path__ + "static/media/logo.3fbc6937.jpg";